/**
 * Session cache for profile / team user detail (EditProfileMain, TeamSideBar).
 * Per-user entries so switching between users (or ticket vs team) does not evict
 * previously loaded users.
 */
const emptyCache = () => ({
  /** @type {Record<string, { userPayload?: any, workingData?: any[], hasFetchedProfile?: boolean, hasFetchedWorkingHours?: boolean }>} */
  byUserId: {},
});

let cache = emptyCache();

export function getProfileSettingsWarmCache() {
  return cache;
}

/** @param {string|number} userId */
export function getProfileWarmEntry(userId) {
  if (userId == null || userId === '') return null;
  return cache.byUserId[String(userId)] ?? null;
}

export function mergeProfileSettingsWarmCache(partial) {
  const uid = partial?.userId != null ? String(partial.userId) : null;
  if (!uid) return;
  const prev = cache.byUserId[uid] ?? {};
  cache.byUserId[uid] = {
    ...prev,
    ...(partial.userPayload !== undefined && { userPayload: partial.userPayload }),
    ...(partial.workingData !== undefined && { workingData: partial.workingData }),
    ...(partial.hasFetchedProfile !== undefined && {
      hasFetchedProfile: partial.hasFetchedProfile,
    }),
    ...(partial.hasFetchedWorkingHours !== undefined && {
      hasFetchedWorkingHours: partial.hasFetchedWorkingHours,
    }),
  };
}

export function clearProfileSettingsWarmCache() {
  cache = emptyCache();
}

/** Whether session warm cache already has profile / hours for this user (revisit UX). */
export function getProfileWarmBootstrapForUser(userId) {
  if (!userId) {
    return { profileReady: false, hoursReady: false };
  }
  const e = getProfileWarmEntry(userId);
  if (!e) {
    return { profileReady: false, hoursReady: false };
  }
  return {
    profileReady: !!(e.hasFetchedProfile && e.userPayload),
    hoursReady: !!(e.hasFetchedWorkingHours && Array.isArray(e.workingData)),
  };
}
